import { createSignal, Show, Signal } from "solid-js";
import STInput from "../st-input/st-input";
import './inline-edit.css'

export class InlineEditProps {
    disabled?: boolean
    model: Signal<string> = createSignal('')
    onSave?: (v: string) => Promise<void> | void
}

interface InlineEditInfo {
    el: HTMLElement
    save: () => Promise<void>
    isEditing: Signal<boolean>
}

let activeEdit: InlineEditInfo | null = null

const onMouseupInlineEdit = (ev: MouseEvent) => {
    if (activeEdit) {
        if (!activeEdit.el.contains((ev.target as HTMLElement))) {
            activeEdit.save()
            activeEdit.isEditing[1](false)
            document.removeEventListener('mouseup', onMouseupInlineEdit)
        }
    }
}

export default function InlineEdit(props: InlineEditProps) {
    let input: HTMLInputElement;

    const isEditingSignal = createSignal(false)
    const [isEditing, setIsEditing] = isEditingSignal

    const [value, setValue] = props.model

    const onKeydown = () => {

    }

    const onClickEdit = (e: MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
        e.stopImmediatePropagation()
        
        if (!props.disabled) {
            setIsEditing(true)
            input.focus()
            document.addEventListener('mouseup', onMouseupInlineEdit)
            activeEdit = { el: input, isEditing: isEditingSignal, save }
        }
    }

    const save = async () => {
        try {
            if (props.onSave && typeof props.onSave === 'function') {
                await props.onSave(value());
            }
        } catch(e) {
            console.error(e);
        }

        setIsEditing(false);
    }

    return (
        <div class="inline-edit">
            <Show when={!isEditing()}>
                <div class="inline-edit-value" onKeyDown={onKeydown} tabindex="0">
                    <div>{value()}</div>
                    <Show when={!props.disabled}>
                        <button onClick={onClickEdit} class="inline-edit-button">
                            <span class="fa fa-edit"></span>
                        </button>
                    </Show>
                </div>
            </Show>
            <Show when={isEditing()}>
                <div class="inline-edit-editor">
                    <STInput ref={input!} value={props.model}></STInput>
                </div>
            </Show>
        </div>
    )
}
InlineEdit.defaultProps = new InlineEditProps()